import React from "react";
import { useSearchParams } from "react-router-dom";
import ESourceTemplateBuilder from "./ESourceTemplateBuilder";
import ESourceFormStudio from "./ESourceFormStudio";

/**
 * Default: Form Studio (Word-style). Use ?classic=1 for the previous field canvas.
 */
export default function ESourceBuilderRoute() {
  const [searchParams] = useSearchParams();
  if (searchParams.get("classic") === "1") {
    return <ESourceTemplateBuilder />;
  }
  return <ESourceFormStudio />;
}
